var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import FTLTableCellStyles from "../styles/FTLTableCellStyles.styles";
import clsx from "clsx";
export default React.forwardRef((_a, ref) => {
    var { type = "default", textAlign, noCellBorder, action, isDisabled, isFocusable, minWidth, maxWidth, className = "", width, height } = _a, otherProps = __rest(_a, ["type", "textAlign", "noCellBorder", "action", "isDisabled", "isFocusable", "minWidth", "maxWidth", "className", "width", "height"]);
    const { basic, head } = FTLTableCellStyles({
        textAlign,
        isDisabled,
        noCellBorder,
        isFocusable,
        minWidth,
        maxWidth,
        width,
        height,
    });
    if (type === "default")
        return (React.createElement("td", Object.assign({ ref: ref, className: clsx(className, basic) }, otherProps, { tabIndex: -1 })));
    else
        return (React.createElement("th", Object.assign({ ref: ref, className: clsx(className, head) }, otherProps, { tabIndex: !isFocusable ? -1 : undefined })));
});
//# sourceMappingURL=FTLTableCell.js.map